/**
 * OperatorPageHeader — h1 + meta line + optional actions row.
 */
import { tokens } from "./tokens";

export interface OperatorPageHeaderProps {
  title: string;
  meta?: string;
  actions?: React.ReactNode;
}

export default function OperatorPageHeader({ title, meta, actions }: OperatorPageHeaderProps) {
  return (
    <div style={{ marginBottom: 12, display: "flex", alignItems: "flex-end", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
      <div>
        <h1
          style={{
            fontFamily: tokens.font.display,
            fontWeight: 700,
            fontSize: 28,
            lineHeight: 1.1,
            letterSpacing: -0.5,
            color: tokens.color.textPrimary,
            margin: 0,
          }}
        >
          {title}
        </h1>
        {/* Red editorial underline accent */}
        <div
          aria-hidden="true"
          style={{
            width: 24,
            height: 2,
            background: tokens.color.red,
            marginTop: 5,
            borderRadius: 1,
          }}
        />
        {meta && (
          <div
            style={{
              fontFamily: tokens.font.body,
              fontSize: 12,
              color: tokens.color.textMuted,
              marginTop: 4,
            }}
          >
            {meta}
          </div>
        )}
      </div>
      {actions && <div style={{ display: "flex", alignItems: "center", gap: 8 }}>{actions}</div>}
    </div>
  );
}
